import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "./baseQueryWithReauth";

export const reportPostApi = createApi({
  reducerPath: "reportPostApi",
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    reportPost: builder.mutation({
      query: (body) => ({
        url: "reports",
        method: "POST",
        body,
      }),
    }),
    reportsMy: builder.query({
      query: () => ({
        url: "reports/my",
        method: "GET",
      }),
    }),
  }),
});

export const { useReportPostMutation, useReportsMyQuery } = reportPostApi;
